module.exports = ".flags {\n  padding-left: 25px;\n  padding-right: 25px;\n  display: inline-block;\n\n  width: 100%;\n}\n\n.flags-left {\n  float: left;\n}\n\n.flags-right {\n  margin-left: 40px;\n  float: right;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/table-header-search-modal/table-header-search-modal.component.css
// module id = ./src/app/achelos-iot/modals/table-header-search-modal/table-header-search-modal.component.css
// module chunks = main